import styled from '@emotion/styled'

export const StyledExistingNoteBlock = styled.div`
  padding: 36px 24px 12px;
  background-color: var(--White97);
`

export const StyledNoteNameHeading = styled.h1`
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  padding: 0 0 36px;
`

export const StyledValue = styled.div`
  font-weight: normal;
`

export const StyledCharges = styled.div`
  background: var(--White);
  padding: 24px 12px;
`
